import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import user from './modules/user'
import job from './modules/job'
import transaction from './modules/transaction'
import notification from './modules/notification'
import report from './modules/report'
import faq from './modules/faq'
import support from './modules/support'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    job,
    transaction,
    notification,
    report,
    faq,
    support
  },
  state: {
    controls: {
      showDrawer: true
    }
  },
  mutations: {
    toggleDrawer(state, value) {
      state.controls.showDrawer = value
    }
  }
})
